import { concat, map } from 'lodash'
import { forwardRef, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type BeliefSystemSelectInput_query$key } from '@/__generated__/BeliefSystemSelectInput_query.graphql'
import {
  SingleSelectInput,
  type SingleSelectInputProps,
  type SingleSelectInputRef,
  type SingleSelectOption
} from '@/components'

export type BeliefSystemSelectInputProps = Omit<SingleSelectInputProps, 'options' | 'ref'> & {
  queryRef: BeliefSystemSelectInput_query$key | null | undefined
}

export const BeliefSystemSelectInput = forwardRef<SingleSelectInputRef, BeliefSystemSelectInputProps>(
  ({ queryRef, ...props }, ref) => {
    const queryData = useFragment(
      graphql`
        fragment BeliefSystemSelectInput_query on Query {
          beliefSystems(orderBy: [SEQUENCE_ASC]) {
            nodes {
              name
              rowId
            }
          }
        }
      `,
      queryRef
    )

    return (
      <SingleSelectInput
        options={useMemo<SingleSelectOption[]>(
          () =>
            concat(
              map(queryData?.beliefSystems?.nodes, (beliefSystem) => ({
                label: beliefSystem!.name,
                value: beliefSystem!.rowId
              })),
              [{ label: 'Don’t Show This', value: null }]
            ),
          [queryData?.beliefSystems?.nodes]
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

BeliefSystemSelectInput.displayName = 'BeliefSystemSelectInput'
